
/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  Country,
  LocalizationPreference,
  UpdateLocalizationPreference,
} from '../models';
import {
    CountryFromJSON,
    CountryToJSON,
    LocalizationPreferenceFromJSON,
    LocalizationPreferenceToJSON,
    UpdateLocalizationPreferenceFromJSON,
    UpdateLocalizationPreferenceToJSON,
} from '../models';

export interface UpdateLocalizationPreferenceRequest {
    updateLocalizationPreference: UpdateLocalizationPreference;
}

/**
 * 
 */
export class AccountLocalizationPreferenceApi extends runtime.BaseAPI {

    /**
          */
    async getIsoCountriesRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<Country>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<Country>>({
            path: `/account/api/localization/iso-countries`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(CountryFromJSON);
        return response;
    }

    /**
          */
    async getIsoCountries(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<Country>> {
        const response = await this.getIsoCountriesRaw(initOverrides);
        return response._data;
    }

    /**
          */
    async getLocalizationPreferenceRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<LocalizationPreference>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<LocalizationPreference>({
            path: `/account/api/localization/preferences`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=LocalizationPreferenceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getLocalizationPreference(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<LocalizationPreference> {
        const response = await this.getLocalizationPreferenceRaw(initOverrides);
        return response._data;
    }

    /**
          */
    async updateLocalizationPreferenceRaw(requestParameters: UpdateLocalizationPreferenceRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<LocalizationPreference>> {
        if (requestParameters['updateLocalizationPreference'] == null) {
            throw new runtime.RequiredError(
                'updateLocalizationPreference',
                'Required parameter "updateLocalizationPreference" was null or undefined when calling updateLocalizationPreference().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<LocalizationPreference>({
            path: `/account/api/localization/preferences`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLocalizationPreferenceToJSON(requestParameters['updateLocalizationPreference']),
        }, initOverrides);

        if (response._data) { response._data=LocalizationPreferenceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async updateLocalizationPreference(requestParameters: UpdateLocalizationPreferenceRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<LocalizationPreference> {
        const response = await this.updateLocalizationPreferenceRaw(requestParameters, initOverrides);
        return response._data;
    }

}
